import { func } from 'prop-types';
import { CALL_API } from '../middleware/api';

export const FETCH_CUSTOMERS = "FETCH_CUSTOMERS";
export const SUCCESS_FETCH_CUSTOMERS = "SUCCESS_FETCH_CUSTOMERS";
export const FAILURE_FETCH_CUSTOMERS = "FAILURE_FETCH_CUSTOMERS";
export const CLEAR_CUSTOMERS = "CLEAR_CUSTOMERS";

export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const SUCCESS_UPDATE_CUSTOMER = "SUCCESS_UPDATE_CUSTOMER";
export const FAILURE_UPDATE_CUSTOMER = "FAILURE_UPDATE_CUSTOMER";
export const CLEAR_UPDATE_CUSTOMER = "CLEAR_UPDATE_CUSTOMER";

export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const SUCCESS_CREATE_CUSTOMER = "SUCCESS_CREATE_CUSTOMER";
export const FAILURE_CREATE_CUSTOMER = "FAILURE_CREATE_CUSTOMER";
export const CLEAR_CREATE_CUSTOMER = "CLEAR_CREATE_CUSTOMER";

export const CUSTOMER_IS_BUSY = "CUSTOMER_IS_BUSY";
export const SUCCESS_CUSTOMER_IS_BUSY = "SUCCESS_CUSTOMER_IS_BUSY";
export const FAILURE_CUSTOMER_IS_BUSY = "FAILURE_CUSTOMER_IS_BUSY";

export const FETCH_CHECK_CUSTOMER = "FETCH_CHECK_CUSTOMER";
export const SUCCESS_FETCH_CHECK_CUSTOMER = "SUCCESS_FETCH_CHECK_CUSTOMER";
export const FAILURE_FETCH_CHECK_CUSTOMER = "FAILURE_FETCH_CHECK_CUSTOMER";
export const CLEAR = "CLEAR";

export const FETCH_RESET_PASSWORD = "FETCH_RESET_PASSWORD";
export const SUCCESS_RESET_PASSWORD = "SUCCESS_RESET_PASSWORD";
export const FAILURE_RESET_PASSWORD = "FAILURE_RESET_PASSWORD";
export const CLEAR_RESET_PASSWORD = "CLEAR_RESET_PASSWORD";

export const FETCH_SEND_SMS = "FETCH_SEND_SMS";
export const SUCCESS_SEND_SMS = "SUCCESS_SEND_SMS";
export const FAILURE_SEND_SMS = "FAILURE_SEND_SMS";
export const CLEAR_SEND_SMS = "CLEAR_SEND_SMS";

export function sendSms(phone, text) {
    return {
        type: FETCH_SEND_SMS,
        [CALL_API]: {
            endpoint: `/api/customers/${phone}/sendSms`,
            method: 'post',
            data: text,
            types: [SUCCESS_SEND_SMS, FAILURE_SEND_SMS]
        }
    }
}

export function clearSmsInfo() {
    return {type: CLEAR_SEND_SMS};
}

export function fetchCustomers(filterData) {
    const query = createQuery(filterData);
    return {
        type: FETCH_CUSTOMERS,
        [CALL_API]: {
            endpoint: `/api/customers${query}`,
            method: 'get',
            types: [SUCCESS_FETCH_CUSTOMERS, FAILURE_FETCH_CUSTOMERS]
        }
    }
}

export function updateCustomer(data) {
    const { Id } = data;
    return {
        type: UPDATE_CUSTOMER,
        [CALL_API]: {
            endpoint: `/api/customers/${Id}`,
            method: 'post',
            types: [SUCCESS_UPDATE_CUSTOMER, FAILURE_UPDATE_CUSTOMER],
            data
        }
    }
}

export function createCustomer(data) {
    return {
        type: CREATE_CUSTOMER,
        [CALL_API]: {
            endpoint: `/api/customers/`,
            method: 'post',
            types: [SUCCESS_CREATE_CUSTOMER, FAILURE_CREATE_CUSTOMER],
            data
        }
    }
}

export function fetchCustomerIsBusy(phone, error) {
    return {
        type: CUSTOMER_IS_BUSY,
        [CALL_API]: {
            endpoint: `/api/customers/${phone}/is-busy`,
            method: 'get',
            types: [SUCCESS_CUSTOMER_IS_BUSY, FAILURE_CUSTOMER_IS_BUSY],
        },
        error
    }
}


export function clearUpdateCustomer() {
    return { type: CLEAR_UPDATE_CUSTOMER }
}

export function clearCreateCustomer() {
    return { type: CLEAR_CREATE_CUSTOMER }
}


export function clearCustomerExists(phone) {
    return { type: CLEAR_CREATE_CUSTOMER, phone }
}

const createQuery = ({ name, phone, page }) => {
    if (!name && !phone && !page)
        return '';
    let nameQuery = name ? `name=${name}` : '';
    const phoneQuery = phone ? `phone=${encodeURIComponent(phone)}` : '';
    const pageQuery = page ? `page=${page-1}` : '';

    return `?${[nameQuery, phoneQuery, pageQuery].filter(a => a != '').reduce((accm, val) => `${accm}&${val}`)}`;
}

export function getUserByPhone(data) {
    const { phone } = data;
    return {
        type: FETCH_CHECK_CUSTOMER,
        [CALL_API]: {
            endpoint: `/api/customers/${phone}`,
            method: 'get',
            types: [SUCCESS_FETCH_CHECK_CUSTOMER, FAILURE_FETCH_CHECK_CUSTOMER]
        }
    }
}

export function resetPassword(data) {
    const { phone } = data;
    return {
        type: FETCH_RESET_PASSWORD,
        [CALL_API]: {
            endpoint: `/api/customers/${phone}/pwd-reset`,
            method: 'post',
            types: [SUCCESS_RESET_PASSWORD, FAILURE_RESET_PASSWORD]
        }
    }
}

export function clear() {
    return { type: CLEAR }
}

export function clearCustomers() {
    return { type: CLEAR_CUSTOMERS };
}

export function clearResetPassword() {
    return { type: CLEAR_RESET_PASSWORD };
}


// WEBPACK FOOTER //
// ./src/actions/customers.js